// studentSubscriptionHelper.js
// For PW we only use semi and annual periods
export const calculateGuestExpiration = (type) => {
  const date = new Date();
  if (type?.includes('semi')) {
    date.setMonth(date.getMonth() + 6);
  } else {
    date.setFullYear(date.getFullYear() + 1);
  }
  return date;
};
